import { render } from "./TheNotificationsDropdownMenu.vue?vue&type=template&id=2b988f34&scoped=true"
import script from "./TheNotificationsDropdownMenu.vue?vue&type=script&lang=js"
export * from "./TheNotificationsDropdownMenu.vue?vue&type=script&lang=js"

import "../css/adminlte.css?vue&type=style&index=0&id=2b988f34&lang=css&scoped=true&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b988f34"]])

export default __exports__